//fetchEmployeeFromAdmin

import api from "./api";


export const fetchEmployeeFromAdmin=async(state,district,designation)=>{
      let url = `/api/employee-posting/update-personal-info?stateId=${state}`;
    
    if (district) {
        url += `&districtId=${district}`;
    }

    if (designation) {
        url += `&designationId=${designation}`;
    }
    // Make the API request
    const response =await api.get(url);
    return response.data;

}

export const fetchEmployeeFromSelf=async(employeeId)=>{
    const response = await api.get(`/api/employee-posting/by-employee?employeeId=${employeeId}`);
    return response.data;
    // Make the API request
 

}


export const fetchExistingEmployees=async(state,district,designation)=>{
      let url = `/api/employee-posting/mail-sent?stateId=${state}`;
    
    if (district) {
        url += `&districtId=${district}`;
    }
    
    if (designation) {
        url += `&designationId=${designation}`;
    }
    // Make the API request
    const response =await api.get(url);
    return response.data;

}


export const fetchEmployeeDetails=async(state,district,designation)=>{
      let url = `/api/employee-posting/filter-based-designation?stateId=${state}`;
    
    if (district) {
        url += `&districtId=${district}`;
    }

    if (designation) {
        url += `&designationId=${designation}`;
    }
    // Make the API request
    const response =await api.get(url);
    return response.data;

}


export const fetchWaitingApprovals=async(state,district,designation)=>{
      let url = `/api/employee-transfer/requests`;
    
    if (district) {
        url += `&districtId=${district}`;
    }
    
    if (designation) {
        url += `&designationId=${designation}`;
    }
    // Make the API request
    const response =await api.get(url);
    return response.data;

}

export const getTransferDetails = async (id) => {
    const response = await api.get(`/api/employee-transfer/${id}/details`);
    return response.data;
};

export const updateApprovalStatus = async (id, status) => {
    const response = await api.patch(
        `/api/employee-transfer/${id}/status`,
        {
            status
        }
    );

    return response.data;
};

export const fetchWaitingTransfers=async(state,district,designation)=>{
      let url = `/api/employee-transfer/approved`;
    
    if (district) {
        url += `&districtId=${district}`;
    }
    
    if (designation) {
        url += `&designationId=${designation}`;
    }
    // Make the API request
    const response =await api.get(url);
    return response.data;

}

export const updateTransferPosting = async (id, status, toDate) => {
    const response = await api.patch(
        `/api/employee-transfer/${id}/posting`,
        {
            status,
            toDate
        }
    );

    return response.data;
};




export const getTransfers = async (
    state,
    district,
    year,
    month,
    status
) => {

    let url = "/api/employee-transfer/list?";

    const params = [];

    if (state) {
        params.push(`stateId=${state}`);
    }

    if (district && district !== 0) {
        params.push(`districtId=${district}`);
    }

    if (year) {
        params.push(`year=${year}`);
    }

    if (month) {
        params.push(`month=${month}`);
    }

    if (status && status !== "All") {
        params.push(`status=${status}`);
    }

    url += params.join("&");

    const response = await api.get(url);

    return response.data;
};

// http://localhost:8080/api/employee-posting/employees-personal-info-list?stateId=3&districtId=1

export const fetchCMREmployeeFromAdmin=async(state,district)=>{
      let url = `/api/employee-posting/employees-personal-info-list?stateId=${state}`;
    
    if (district) {
        url += `&districtId=${district}`;
    }


    // Make the API request
    const response =await api.get(url);
    return response.data;

}


export const updateEmployeeStatus = async (id, status) => {
  try {
    const response = await api.patch(`/api/employee-posting/update-status/${id}?status=${status}`);
    return response.data;
  } catch (error) {
    console.error('Error updating employee status:', error);
    throw error;
  }
};